module.exports = __webpack_public_path__ + "img/classification.8bc9aa17.svg";